import {
    Typography,
    Card,
    CardBody,
  } from "@material-tailwind/react";
  
  
  interface FeatureCardProps {
    icon: React.ElementType;
    title: string;
    children: React.ReactNode;
  }
  
  export function FeatureCard({ icon: Icon, title, children }: FeatureCardProps) {
    return (
      <Card  {...({} as any)} color="transparent" shadow={false}>
        <CardBody  {...({} as any)} className="grid justify-start">
          <div className="mb-4 grid h-12 w-12 place-content-center rounded-lg bg-gray-900 p-2.5 text-left text-white">
            <Icon className="h-6 w-6" />
          </div>
          <Typography  {...({} as any)} variant="h5" color="blue-gray" className="mb-2">
            {title}
          </Typography>
          <Typography  {...({} as any)} className=" font-normal !text-gray-500">
            {children}
          </Typography>
        </CardBody>
      </Card>
    );
  }

  export default FeatureCard;
  